(function() {
  const SHOPIFY_API_URL = 'https://'+document.querySelector('meta[name="wall-domain"]').content+'/api/2024-07/graphql.json';
  const SHOPIFY_ACCESS_TOKEN = document.querySelector('meta[name="wall-storefront-key"]').content;

  // GraphQL Query for Cart Creation
  const cartCreateQuery = `
    mutation createCart($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          createdAt
          updatedAt
          checkoutUrl
          lines(first: 10) {
            edges {
              node {
                id
                attributes {
                  key
                  value
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                  }
                }
                quantity
              }
            }
          }
          attributes {
            key
            value
          }
          note
          estimatedCost {
            totalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  // This will be flipped to "true" when we want to trigger a normal checkout (without our hook running)
  let useNormalCheckout = false;

  const checkoutButtonSelector = '[name="checkout"]';
  document.body.addEventListener('submit', function(evt) {
    if(evt.target.id != 'main-cart-form') {
      return;
    }

    const $button = evt.target.querySelector('.checkout-button');
    const $form = evt.target;

    // Filters out any events not matching our checkout buttons
    if (! ($button.matches(checkoutButtonSelector) || $button.closest('button')?.matches(checkoutButtonSelector))) {
      return;
    }

    // In case of "normal" checkout, just stop here so the normal events happen instead
    if (useNormalCheckout) {
      return;
    }

    // If we have a form, validate it first
    if ($form) {
      const $termsCheckbox = $form.querySelector('#CartTerms,#CartDrawerTerms');
      if ($termsCheckbox && !$termsCheckbox.checked) {
        return;
      }
    }

    // Disable default checkout behavior
    evt.preventDefault();

    // Starts the async processing
    return (async function($button, $form) {
      // Function to fetch cart data
      async function fetchCartData() {
        try {
          const response = await fetch('/pages/ajax-controller?view=cart-logic');
          if (!response.ok) {
            throw new Error(`Error fetching cart data: ${response.statusText}`);
          }
          return await response.json();
        } catch (error) {
          console.error('Failed to fetch cart data:', error);
          throw error;
        }
      }

      // Function to create a cart
      async function createCart(cartInput) {
        try {
          const response = await fetch(SHOPIFY_API_URL, {
            method: 'POST',
            headers: {
              'X-Shopify-Storefront-Access-Token': SHOPIFY_ACCESS_TOKEN,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              query: cartCreateQuery,
              variables: { input: cartInput }
            })

          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const { data } = await response.json();

          if (data.errors?.length > 0) {
            throw new Error("API error: "+JSON.stringify(data.errors));
          } else if (data.cartCreate.userErrors?.length > 0) {
            throw new Error("API user error: "+JSON.stringify(data.cartCreate.userErrors));
          } else if (data.cartCreate.cart.lines.edges.length == 0) {
            throw new Error("No line items were added on the Wall cart.");
          }

          console.log('Cart Created Successfully:', data.cartCreate.cart);
          window.location = data.cartCreate.cart.checkoutUrl;
        } catch (error) {
          console.error('Error creating cart:', error);
          // Optional: Retry logic or user notification
        }
      }

      // Function to generate the cartInput JSON object
      function createCartInput(items, attributes, note) {
        return {
          lines: items.map(item => ({
            attributes: Object.keys(item.properties).map(key => ({
              key: key,
              value: item.properties[key]
            })),
            merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
            quantity: parseInt(item.quantity, 10)
          })),
          attributes: Object.keys(attributes).map(key => ({
            key: key,
            value: attributes[key]
          })),
          note,
        };
      }

      try {
        // Start processing the cart
        const cart = await fetchCartData();

        // Redirects to correct wall cart (if any)
        if (cart.wall_cart && cart.properties_json) {
          const cartInput = createCartInput(cart.properties_json, cart.attributes, cart.note);
          // Call the function to create a cart
          createCart(cartInput);
          return;
        }

        // Handle case where no special cart logic is needed
        useNormalCheckout = true;
        $button.click();
      } catch (error) {
        console.error('An unexpected error occurred:', error);
      }
    })($button, $form);
  });
})();

function validateProductForm(btn) {
  let form = btn.closest('form');

  let valid = true;

  if(form.querySelector('.custom-field')) {
    let i = 1;
    form.querySelectorAll('.custom-field').forEach(function(field) {
      let personalized = false;
      if(field.value.length > 0) personalized = true;
      if(field.classList.contains('required') && field.value.length < 1) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      }
      else if(field.classList.contains('required') && field.classList.contains('select') && field.value == '0' ) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      }
      else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }

      if (personalized) {
        if(form.querySelector('input[name="properties[_personalized_'+i+']"]') == null) {
          let input = document.createElement("input");
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', 'properties[_personalized_'+i+']');
          input.setAttribute('value', 'true');
          form.appendChild(input);
        }
        else {
          form.querySelector('input[name="properties[_personalized_'+i+']"]').value = 'true';
        }
      }
      i++;
    });
  }

  return valid;
}

/*function validateCheckSpelling(btn) {
  let parent = btn.parentNode;
  let valid = false;

  if(parent.querySelector('input[name="check-spelling"]') != null) {
    if(parent.querySelector('input[name="check-spelling"]').checked) {
      valid = true;
    }
  }

  return valid;
}*/

if(document.querySelector(".Form__Input.custom-field")) {
  document.querySelectorAll(".Form__Input.custom-field").forEach(function(el) {
    el.addEventListener("keyup", (e) => {
      let field = e.target;
      if(field.classList.contains('required') && field.value.length < 1) {
        field.closest('.field-container').classList.add('error');
      }
      else if(field.classList.contains('required') && field.classList.contains('select') && field.value == '0' ) {
        field.closest('.field-container').classList.add('error');
      }
      else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }

      if(el.closest('.field-container').querySelector('label .fee-product-price')) {
        let priceEl = el.closest('.field-container').querySelector('label .fee-product-price');
        if(field.value.length > 0) {
          priceEl.classList.remove('hidden')
        }
        else {
          priceEl.classList.add('hidden')
        }
      }
    });
  });

}

if(document.querySelector(".form .single-add-to-cart-button")) {
  document.querySelectorAll(".form .single-add-to-cart-button").forEach(function(el) {
    el.addEventListener("click", (e) => {
      let valid = validateProductForm(e.target);
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  });
}

/*$(document).on('click', 'label[for="check-spelling"]', function(e) {
  let input = $(this).closest('.check-spelling-container').find('input');
  input.checked = !input.checked;
});
$(document).on('click', '.custom-checkbox .checkmark', function(e) {
  let input = e.target.closest('.check-spelling-container').querySelector('input');
  input.checked = !input.checked;
});*/

/*$(document).on('click', '.checkout-button', function(e) {
  let valid = validateCheckSpelling(e.target);
  if (!valid) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.check-spelling-container').classList.add('error');
    return false;
  }
  else {
    document.querySelector('.check-spelling-container').classList.remove('error');
  }
});*/

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

if(document.querySelector('[data-add-to-cart]')) {
  const addToCartButton = document.querySelector('[data-add-to-cart]');

  const handleFeeProduct = (fieldSelector, feePriceSelector, fieldPriceName) => {
    if(document.querySelector(fieldSelector)) {
      const field = document.querySelector(fieldSelector);
      const fieldContainer = field.closest('.field-container');
      const fieldPrice = document.querySelector(feePriceSelector).getAttribute(feePriceSelector.slice(1, -1));

      if (field.value != "") {
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${fieldPriceName}]`;
        input.value = fieldPrice;
        fieldContainer.appendChild(input);
      } else {
        const existingInput = document.querySelector(`[name="properties[${fieldPriceName}]"]`);
        if (existingInput) {
          existingInput.remove();
        }
      }
    }
  };

  const removeAllFeeProducts = (feeProductName) => {
    const allFeeProductProperties = document.querySelectorAll(`[name="properties[${feeProductName}]"]`);
    allFeeProductProperties.forEach(feeProductPropertie => feeProductPropertie.remove());
  };

  addToCartButton.addEventListener('click', function() {
    handleFeeProduct('.Form__Input.custom-field.input__field.input__field--text', '[data-fee-product-1-price]', '_fee_product_1_price');
    handleFeeProduct('.Form__Input.custom-field.input__field.input__field--text#field2', '[data-fee-product-2-price]', '_fee_product_2_price');
    handleFeeProduct('.Form__Input.custom-field.input__field.input__field--text#field3', '[data-fee-product-3-price]', '_fee_product_3_price');

    const checkCartAdd = setInterval(function() {
      if (document.body.classList.contains('open-cc') && document.body.classList.contains('open-cart')) {
        removeAllFeeProducts('_fee_product_1_price');
        removeAllFeeProducts('_fee_product_2_price');
        removeAllFeeProducts('_fee_product_3_price');
        clearInterval(checkCartAdd);
      }
    }, 100);
  });
}
    var links = document.links; 
    for(let i = 0, linksLength = links.length; i < linksLength; i++){
    if (links[i].hostname !== window.location.hostname) { 
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    } 
    }
